module.exports = __webpack_public_path__ + "static/media/ig-icon.aafdbbb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/icons/ig-icon.svg
// module id = 58
// module chunks = 0